<script setup lang="ts">
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import { getUserCallback } from '@/lib/util/store';
import { onMounted, ref } from 'vue';

const props = withDefaults(defineProps<{
  user?: USER
  getUserIfNotPresent?: boolean
  /** Whether this component should display an alert when an error occurs like failure to connect to server (DEFAULT: true) */
  alertErrors?: boolean
}>(), {
  alertErrors: true
})

// Computational
const toFetchUser = props.getUserIfNotPresent && !props.user

const user = ref(props.user);
const isLoading = ref(toFetchUser ? true : false);
const isOffline = ref(false);

onMounted(async () => {
  if (toFetchUser) {
    // get user
    getUserCallback((_user, err) => {
      isLoading.value = false;
      user.value = _user;

      if (err && err == "offline") isOffline.value = true;
      else if (err) console.error(err);
    }, { minified: false })
  }
})
</script>

<template>
  <template v-if="isOffline">
    <div>
      <Button variant="secondary_outline_text" disabled>Offline</Button>
    </div>
  </template>
  <template v-else-if="isLoading">
    <Avatar class="tw-w-[48px] tw-h-[48px]">
      <div class="tw-rounded-full tw-bg-gray-700/50 tw-animate-pulse"></div>
    </Avatar>
  </template>
  <Avatar class="tw-w-[48px] tw-h-[48px]" v-else-if="user">
    <AvatarImage :src="user.googleProfile.photos[0].value" :alt="user.userName + ' profile pic'" />
    <AvatarFallback :delay-ms="3000">{{ user.userName.charAt(0).toUpperCase() }}</AvatarFallback>
  </Avatar>
  <div v-else>
    <Button as-child variant="default_outline_text">
      <a href="/login">Login</a>
    </Button>
  </div>
</template>